import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { auth } from "./firebase";
import { signOut } from "firebase/auth"; // Import signOut from firebase/auth
import IdeaList from "./IdeaList";
import IdeaDetail from "./IdeaDetail";
import Login from "./Login";

function Header({ user }) {
    const handleSignOut = async () => {
        try {
            await signOut(auth);
        } catch (error) {
            console.error("Error signing out:", error);
        }
    };

    return (
        <nav className="navbar navbar-dark bg-dark mb-3">
            <div className="container-fluid d-flex justify-content-between">
                <span className="navbar-brand mb-0 h1">Team Ideas 💡</span>
                <button className="btn btn-outline-light" onClick={handleSignOut}>
                    Sign Out
                </button>
            </div>
        </nav>
    );
}

function App() {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged((currentUser) => {
            setUser(currentUser);
            setLoading(false);
        });
        return () => unsubscribe();
    }, []);

    if (loading) {
        return (
            <div className="d-flex justify-content-center align-items-center vh-100">
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        );
    }

    return (
        <Router>
            {user && <Header user={user} />}
            <Routes>
                {!user ? (
                    <Route path="/*" element={<Login />} />
                ) : (
                    <>
                        <Route path="/" element={<IdeaList user={user} />} />
                        <Route path="/idea/:id" element={<IdeaDetail user={user} />} />
                        <Route path="*" element={<Navigate to="/" />} />
                    </>
                )}
            </Routes>
        </Router>
    );
}

export default App;
